<ham-modal
    [title]="'aumico_mapping_modal_title' | i18next"
    [size]="'sm'"
    [showCancelButton]="true"
    [cancelText]="'aumico_button_cancel' | i18next"
    [saveText]="'aumico_button_save' | i18next"
    [disabled]="stagedAumicoCompany == null"
    [addHorizontalLineBeforeButtons]="true"
    (cancel)="onCancel()"
    (save)="onSave()"
>
    <div class="mapping-modal-body">
        <!-- ─────────── Loading ─────────── -->
        <section *ngIf="mode === 'loading'" class="mapping-modal-body__centered">
            <div class="mapping-modal-body__spinner"></div>
            <p class="mapping-modal-body__paragraph">{{ 'aumico_mapping_loading' | i18next }}</p>
        </section>

        <!-- ─────────── Edit ─────────── -->
            <ng-container
                *ngIf="mode === 'edit' && currentItem$ | async as current"
            >
                <!-- BC company -->
                <div class="mapping-modal-body__field">
                    <label class="mapping-modal-body__field-label">
                        {{ 'aumico_mapping_vendor_company_label' | i18next }}
                    </label>
                    <div class="mapping-modal-body__readonly-card">
                        {{ current.vendorCompany.externalCompanyName }}
                    </div>
                </div>

                <!-- Arrow divider -->
                <div class="mapping-modal-body__arrow">↓</div>

                <!-- Currently mapped (info only) — shown when an existing mapping is in place
                     AND the user hasn't staged something new yet. -->
                <div
                    *ngIf="current.suggestedAumicoCompany as match"
                    class="mapping-modal-body__current-mapping"
                >
                    {{ 'aumico_mapping_currently_mapped_to' | i18next }}
                    <strong>{{ match.name }}</strong>
                </div>

                <!-- Aumico section: search input or staged card, both owned by the shared component -->
                <div class="mapping-modal-body__field">
                    <label class="mapping-modal-body__field-label">
                        {{ 'aumico_mapping_aumico_company_label' | i18next }}
                    </label>

                    <aumico-integrations-search-company-input-field
                        [options]="aumicoCatalog$ | async"
                        [isLoading]="searchIsLoading"
                        [hasError]="searchError"
                        [(selectedCompany)]="stagedAumicoCompany"
                    ></aumico-integrations-search-company-input-field>
            </div>
        </ng-container>
    </div>
</ham-modal>
